// Варианты, которые экран РЕАЛЬНО предлагает нажать. Один счёт на двоих:
// по нему превью рисует варианты, а `hasAnswerableInput` решает, есть ли чем
// отвечать. Пока это были два разных счёта, `fill_blank` с добавленными, но
// не заполненными вариантами запирал репетицию: продьюсер считал СТРОКИ
// списка, а экран рисовал чипы только непустым словам.
import type { QuizBlock } from '@/types/blocks'
import type { ContentLang } from '@/features/editor/editorSlice'
import { getDisplayBody } from '../blocks/quizBodySync'

export interface AnswerableOption {
  text: string
  /** Индекс в ИСХОДНОМ списке вариантов — им нумеруются ответ и проверка. */
  index: number
  isCorrect: boolean
}

/** `strict` — холст редактора: только язык правки, без подстановки второго. */
export const answerableOptions = (
  block: QuizBlock,
  lang: ContentLang,
  strict = false,
): AnswerableOption[] => {
  const answers = getDisplayBody(block, lang, strict).answers
  // `fill_blank` рисует слово чипом — пустое нажать нечем. `choice` рисует
  // карточку КАЖДОМУ варианту, включая ещё не заполненный, и она нажимается.
  return block.quizType === 'fill_blank'
    ? answers.flatMap((a, index) =>
        a.text ? [{ text: a.text, index, isCorrect: a.isCorrect }] : [],
      )
    : answers.map((a, index) => ({ text: a.text ?? '', index, isCorrect: a.isCorrect }))
}
